
import Hero from "../components/Hero";
import hotelImg from "../assests/images/hotel-bg.jpg";

import {
    FaShieldAlt,
    FaLock,
    FaUserSecret,
    FaCookieBite,
    FaInfoCircle,
    FaChevronRight,
    FaCheckCircle,
    FaArrowRight,
} from "react-icons/fa";

export default function PrivacyPolicy() {
    const quickLinks = [
        "Introduction",
        "Information We Collect",
        "How We Use Data",
        "Security",
        "Sharing",
        "Cookies",
        "Your Rights",
        "Contact",
    ];

    const trustPoints = [
        "Secure information handling",
        "Trusted service partners",
        "Privacy-focused practices",
    ];

    return (
        <div className="w-full overflow-hidden bg-[#F5F8FA]">

            {/* HERO */}
            <Hero
                variant="inner"
                title="Privacy Policy"
                subtitle="Your privacy matters to us. Learn how we collect, use and protect your information."
                backgroundImage={hotelImg}
            />

            {/* PRIVACY INTRO */}
            <section className="relative overflow-hidden bg-[#F5F8FA] py-16 sm:py-20 lg:py-28">

                <div className="pointer-events-none absolute -right-40 top-10 h-96 w-96 rounded-full bg-[#0B5552]/5 blur-3xl" />

                <div className="pointer-events-none absolute -left-40 bottom-0 h-80 w-80 rounded-full bg-[#D7A74A]/10 blur-3xl" />

                <div className="relative z-10 mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12 xl:px-16">

                    <div className="grid grid-cols-1 items-stretch gap-6 lg:grid-cols-[1.4fr_0.6fr] lg:gap-8">

                        {/* INTRO CARD */}
                        <div className="group relative overflow-hidden rounded-[28px] border border-[#DCE6EC] bg-white p-7 shadow-[0_20px_60px_rgba(15,35,50,0.05)] transition-all duration-500 hover:shadow-[0_25px_70px_rgba(15,35,50,0.09)] sm:p-9 lg:p-12">

                            <div className="absolute left-0 top-0 h-full w-1 bg-gradient-to-b from-[#0B5552] to-[#D7A74A]" />

                            <div className="flex flex-col gap-5 sm:flex-row sm:items-start sm:gap-6">

                                <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-[#E8F3F2] text-[#8B0000] transition-all duration-300 group-hover:bg-[#8B0000] group-hover:text-white">
                                    <FaShieldAlt className="text-xl" />
                                </div>

                                <div className="min-w-0">

                                    <div className="mb-4 inline-flex items-center gap-3 rounded-full border border-[#0B5552]/10 bg-[#F5F8FA] px-4 py-2">

                                        <span className="h-1.5 w-1.5 rounded-full bg-[#D7A74A]" />

                                        <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#8B0000]">
                                            Your Privacy
                                        </span>

                                    </div>

                                    <h2 className="text-2xl font-extrabold leading-tight tracking-tight text-[#172B35] sm:text-3xl lg:text-[40px]">
                                        Your Information
                                        <span className="block text-[#8B0000]">
                                            Matters to Us
                                        </span>
                                    </h2>

                                    <div className="mt-5 h-1 w-16 rounded-full bg-[#D7A74A]" />

                                    <p className="mt-6 max-w-3xl text-sm leading-8 text-[#71808A] sm:text-base">
                                        We are committed to protecting your
                                        personal information and maintaining
                                        your trust. This Privacy Policy explains
                                        how we collect, use and safeguard the
                                        information you provide when using our
                                        website and services.
                                    </p>

                                    <p className="mt-4 max-w-3xl text-sm leading-8 text-[#71808A] sm:text-base">
                                        At Dubai Hotel Rates, we believe that
                                        a comfortable travel experience begins
                                        with confidence, transparency and
                                        responsible handling of your information.
                                    </p>

                                </div>
                            </div>
                        </div>

                        {/* TRUST CARD */}
                        <div className="group relative overflow-hidden rounded-[28px] bg-[#0B5552] p-7 shadow-[0_25px_70px_rgba(11,85,82,0.16)] transition-all duration-500 hover:-translate-y-1 sm:p-9 lg:p-10">

                            <div className="pointer-events-none absolute -right-20 -top-24 h-80 w-80 rounded-full border border-white/10 transition-transform duration-700 group-hover:scale-110" />

                            <div className="pointer-events-none absolute -bottom-28 -left-20 h-72 w-72 rounded-full bg-[#D7A74A]/10 blur-3xl" />

                            <div className="relative z-10 flex h-full flex-col">

                                <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-[#D7A74A] text-[#173F3E] shadow-lg">
                                    <FaLock className="text-2xl" />
                                </div>

                                <p className="mt-8 text-[10px] font-bold uppercase tracking-[0.22em] text-[#E8C879]">
                                    Our Commitment
                                </p>

                                <h3 className="mt-3 font-serif text-2xl font-bold leading-tight !text-white sm:text-3xl">
                                    Safe & Secure
                                    <span className="block text-[#E8C879]">
                                        Information
                                    </span>
                                </h3>

                                <p className="mt-4 text-sm leading-7 text-white/70">
                                    We take reasonable measures to help keep
                                    your personal information secure and
                                    handle it responsibly.
                                </p>

                                <div className="mt-8 space-y-4 border-t border-white/15 pt-6">

                                    {trustPoints.map((item, index) => (
                                        <div
                                            key={index}
                                            className="flex items-center gap-3"
                                        >
                                            <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-xl bg-white/10">
                                                <FaCheckCircle className="text-xs text-[#E8C879]" />
                                            </span>

                                            <span className="text-xs font-medium text-white/80 sm:text-sm">
                                                {item}
                                            </span>
                                        </div>
                                    ))}

                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* MAIN POLICY AREA */}
            <section className="relative overflow-hidden bg-white py-16 sm:py-20 lg:py-24">

                <div className="pointer-events-none absolute -right-40 top-20 h-96 w-96 rounded-full bg-[#D7A74A]/10 blur-3xl" />

                <div className="pointer-events-none absolute -left-40 bottom-0 h-96 w-96 rounded-full bg-[#0B5552]/5 blur-3xl" />

                <div className="relative z-10 mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12 xl:px-16">

                    {/* SECTION HEADING */}
                    <div className="mb-12 max-w-2xl">

                        <div className="mb-5 inline-flex items-center gap-3 rounded-full border border-[#0B5552]/10 bg-[#F5F8FA] px-4 py-2">

                            <span className="h-1.5 w-1.5 rounded-full bg-[#D7A74A]" />

                            <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#8B0000]">
                                Privacy & Protection
                            </span>

                        </div>

                        <h2 className="text-3xl font-extrabold leading-tight tracking-tight text-[#172B35] sm:text-4xl lg:text-5xl">
                            Understanding Our
                            <span className="text-[#8B0000]">
                                {" "}Privacy Practices
                            </span>
                        </h2>

                        <div className="mt-5 h-1 w-16 rounded-full bg-[#D7A74A]" />

                        <p className="mt-5 max-w-xl text-sm leading-8 text-[#71808A] sm:text-base">
                            Explore how your information is collected,
                            used and protected when you interact with
                            Dubai Hotel Rates.
                        </p>

                    </div>

                    <div className="grid gap-8 lg:grid-cols-[280px_1fr]">

                        {/* DESKTOP SIDEBAR */}
                        <aside className="hidden lg:block">

                            <div className="sticky top-24 rounded-[24px] border border-[#DCE6EC] bg-[#F5F8FA] p-5 shadow-[0_10px_35px_rgba(15,35,50,0.04)]">

                                <div className="mb-5">

                                    <div className="flex items-center gap-2">

                                        <span className="h-px w-6 bg-[#D7A74A]" />

                                        <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#8B0000]">
                                            On This Page
                                        </p>

                                    </div>

                                    <h3 className="mt-2 text-lg font-extrabold text-[#172B35]">
                                        Quick Navigation
                                    </h3>

                                </div>

                                <div className="space-y-1">

                                    {quickLinks.map((item, index) => (

                                        <a
                                            key={index}
                                            href={`#section-${index}`}
                                            className="group flex items-center gap-3 rounded-xl px-3 py-3 text-xs font-semibold text-[#71808A] transition-all duration-300 hover:bg-white hover:text-[#8B0000] hover:shadow-sm"
                                        >

                                            <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-white text-[9px] font-bold text-[#0B5552] transition-all duration-300 group-hover:bg-[#8B0000] group-hover:text-white">
                                                {String(index + 1).padStart(2, "0")}
                                            </span>

                                            <span className="flex-1">
                                                {item}
                                            </span>

                                            <FaChevronRight className="text-[8px] opacity-0 transition-all duration-300 group-hover:translate-x-1 group-hover:opacity-100" />

                                        </a>

                                    ))}

                                </div>

                                <div className="mt-6 rounded-2xl bg-[#0B5552] p-4">

                                    <FaShieldAlt className="text-xl text-[#D7A74A]" />

                                    <p className="mt-3 text-sm font-bold text-white">
                                        Your Privacy Matters
                                    </p>

                                    <p className="mt-2 text-xs leading-5 text-white/60">
                                        We are committed to responsible
                                        information handling.
                                    </p>

                                </div>

                            </div>
                        </aside>

                        {/* POLICY CONTENT */}
                        <div>

                            {/* MOBILE NAVIGATION */}
                            <div className="mb-6 lg:hidden">

                                <details className="group overflow-hidden rounded-2xl border border-[#DCE6EC] bg-[#F5F8FA]">

                                    <summary className="flex cursor-pointer list-none items-center justify-between px-5 py-4 text-sm font-bold text-[#172B35]">

                                        Privacy Policy Sections

                                        <FaChevronRight className="text-xs text-[#8B0000] transition-transform duration-300 group-open:rotate-90" />

                                    </summary>

                                    <div className="border-t border-[#DCE6EC] p-3">

                                        <div className="grid grid-cols-1 gap-1 sm:grid-cols-2">

                                            {quickLinks.map((item, index) => (

                                                <a
                                                    key={index}
                                                    href={`#section-${index}`}
                                                    className="group flex items-center gap-3 rounded-xl px-3 py-3 text-xs font-semibold text-[#71808A] transition-all duration-300 hover:bg-white hover:text-[#8B0000]"
                                                >

                                                    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-white text-[9px] font-bold text-[#0B5552] group-hover:bg-[#8B0000] group-hover:text-white">
                                                        {String(index + 1).padStart(2, "0")}
                                                    </span>

                                                    {item}

                                                </a>

                                            ))}

                                        </div>

                                    </div>

                                </details>
                            </div>

                            {/* POLICY CARD */}
                            <div className="overflow-hidden rounded-[28px] border border-[#DCE6EC] bg-white shadow-[0_20px_60px_rgba(15,35,50,0.05)]">

                                <div className="h-1 w-full bg-gradient-to-r from-[#0B5552] via-[#8B0000] to-[#D7A74A]" />

                                <div className="p-6 sm:p-8 lg:p-12">

                                    <div className="space-y-0">

                                        <Section
                                            id="section-0"
                                            number="01"
                                            icon={<FaInfoCircle />}
                                            title="Introduction"
                                            text="We value your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, and safeguard your data."
                                        />

                                        <Section
                                            id="section-1"
                                            number="02"
                                            icon={<FaUserSecret />}
                                            title="Information We Collect"
                                            list={[
                                                "Personal details such as name, email and phone number",
                                                "Booking and travel preferences",
                                                "Payment information handled through secure systems",
                                                "Usage data including cookies and analytics information",
                                            ]}
                                        />

                                        <Section
                                            id="section-2"
                                            number="03"
                                            icon={<FaInfoCircle />}
                                            title="How We Use Your Information"
                                            list={[
                                                "Process bookings and payments",
                                                "Improve our website and user experience",
                                                "Send booking confirmations and relevant communications",
                                                "Provide customer support and respond to enquiries",
                                            ]}
                                        />

                                        <Section
                                            id="section-3"
                                            number="04"
                                            icon={<FaLock />}
                                            title="Data Security"
                                            text="We use reasonable security measures, including secure systems and appropriate safeguards, to help protect your personal information from unauthorized access, misuse or disclosure."
                                        />

                                        <Section
                                            id="section-4"
                                            number="05"
                                            icon={<FaShieldAlt />}
                                            title="Sharing of Information"
                                            text="We do not sell your personal information. Information may be shared with trusted service providers or partners when necessary to provide our services, process bookings or support your requests."
                                        />

                                        <Section
                                            id="section-5"
                                            number="06"
                                            icon={<FaCookieBite />}
                                            title="Cookies"
                                            text="We use cookies and similar technologies to improve your browsing experience, understand website usage and support certain website functionality. You can manage cookies through your browser settings."
                                        />

                                        <Section
                                            id="section-6"
                                            number="07"
                                            icon={<FaUserSecret />}
                                            title="Your Rights"
                                            text="You may request access to, correction of, or deletion of your personal information where applicable. You can contact our team if you have questions or requests regarding your personal data."
                                        />

                                        <Section
                                            id="section-7"
                                            number="08"
                                            icon={<FaInfoCircle />}
                                            title="Contact Us"
                                            text="If you have any questions or concerns about this Privacy Policy or how your information is handled, please contact our support team."
                                            last
                                        />

                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

            {/* FINAL CTA */}
            <section className="relative overflow-hidden bg-[#F5F8FA] px-5 pb-16 pt-8 sm:px-8 sm:pb-20 lg:px-12 lg:pb-28 xl:px-16">

                <div className="mx-auto max-w-[1440px]">

                    <div className="group relative overflow-hidden rounded-[28px] bg-[#0B5552] px-6 py-12 text-center shadow-[0_25px_70px_rgba(11,85,82,0.16)] transition-all duration-500 hover:shadow-[0_30px_80px_rgba(11,85,82,0.22)] sm:px-10 sm:py-16 lg:py-20">

                        <div className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full border border-white/10 transition-transform duration-700 group-hover:scale-110" />

                        <div className="pointer-events-none absolute -bottom-28 -right-20 h-80 w-80 rounded-full bg-[#D7A74A]/10 blur-3xl" />

                        <div className="pointer-events-none absolute right-[10%] top-10 h-32 w-32 rounded-full border border-white/10" />

                        <div className="relative z-10 mx-auto max-w-2xl">

                            <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-[#D7A74A] text-2xl text-[#173F3E] shadow-lg transition-transform duration-300 group-hover:-translate-y-1">
                                <FaShieldAlt />
                            </div>

                            <div className="mt-6 flex items-center justify-center gap-3">

                                <span className="h-px w-7 bg-[#D7A74A]" />

                                <span className="text-[10px] font-bold uppercase tracking-[0.22em] text-[#E8C879]">
                                    Your Privacy
                                </span>

                                <span className="h-px w-7 bg-[#D7A74A]" />

                            </div>

                            <h2 className="mt-5 text-2xl font-extrabold leading-tight !text-white sm:text-3xl lg:text-4xl">
                                Your Privacy Is Important To Us
                            </h2>

                            <p className="mx-auto mt-5 max-w-xl text-sm leading-8 text-white/70 sm:text-base">
                                We are committed to handling your information
                                responsibly and providing a safe experience
                                throughout your journey with Dubai Hotel Rates.
                            </p>

                            <a
                                href="/contact-us"
                                className="group/btn mt-8 inline-flex items-center gap-3 rounded-full bg-[#D7A74A] px-6 py-3.5 text-sm font-bold text-[#173F3E] shadow-lg transition-all duration-300 hover:-translate-y-1 hover:bg-[#E8C879] hover:shadow-xl"
                            >

                                Contact Our Team

                                <span className="flex h-7 w-7 items-center justify-center rounded-full bg-[#173F3E] text-[#D7A74A] transition-transform duration-300 group-hover/btn:translate-x-1">
                                    <FaArrowRight className="text-[10px]" />
                                </span>

                            </a>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

/* =========================================================
   REUSABLE POLICY SECTION
========================================================= */

function Section({
    id,
    number,
    icon,
    title,
    text,
    list,
    last = false,
}) {
    return (
        <div
            id={id}
            className={`scroll-mt-28 ${!last
                    ? "mb-9 border-b border-[#DCE6EC] pb-9 sm:mb-10 sm:pb-10"
                    : ""
                }`}
        >

            <div className="group flex items-start gap-4 sm:gap-5">

                {/* NUMBER */}
                <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-[#E8F3F2] text-xs font-bold text-[#0B5552] transition-all duration-300 group-hover:bg-[#8B0000] group-hover:text-white sm:h-12 sm:w-12">
                    {number}
                </div>

                <div className="min-w-0 flex-1">

                    {/* HEADING */}
                    <div className="flex items-start gap-3">

                        <span className="mt-1 text-sm text-[#D7A74A]">
                            {icon}
                        </span>

                        <h2 className="text-lg font-extrabold leading-tight text-[#172B35] transition-colors duration-300 group-hover:text-[#8B0000] sm:text-xl lg:text-2xl">
                            {title}
                        </h2>

                    </div>

                    {/* TEXT */}
                    {text && (
                        <p className="mt-4 text-sm leading-8 text-[#71808A] sm:text-[15px]">
                            {text}
                        </p>
                    )}

                    {/* LIST */}
                    {list && (
                        <div className="mt-5 space-y-3">

                            {list.map((item, index) => (

                                <div
                                    key={index}
                                    className="group/item flex items-start gap-3 rounded-xl p-2 transition-colors duration-300 hover:bg-[#F5F8FA]"
                                >

                                    <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-lg bg-[#E8F3F2] transition-colors duration-300 group-hover/item:bg-[#8B0000]">
                                        <FaCheckCircle className="text-[9px] text-[#0B5552] transition-colors duration-300 group-hover/item:text-white" />
                                    </span>

                                    <p className="text-sm leading-7 text-[#71808A] sm:text-[15px]">
                                        {item}
                                    </p>

                                </div>

                            ))}

                        </div>
                    )}

                </div>
            </div>
        </div>
    );
}